import { render } from "./AddUserView.vue?vue&type=template&id=3f92c108"
import script from "./AddUserView.vue?vue&type=script&lang=js"
export * from "./AddUserView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbook/Documents/personal/freelance-sabdulla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QSelect,QCheckbox,QBtn});
